module.exports = __webpack_public_path__ + "static/media/group_social_media_addon.e4d6c3a6.jpg";